import { Transforms } from 'slate'

const insertImage = (editor, url) => {
  const text = { text: '' }
  const image = [
    { type: 'image', url, children: [text] },
    {
      type: 'paragraph',
      children: [text]
    }
  ]
  Transforms.insertNodes(editor, image)
  Transforms.move(editor)
}

export const withImage = (editor) => {
  const { isInline, isVoid, insertData } = editor

  editor.isInline = (element) => {
    return element.type === 'image' ? false : isInline(element)
  }

  editor.isVoid = (element) => {
    return element.type === 'image' ? true : isVoid(element)
  }

  editor.insertData = (data) => {
    const { files } = data

    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader()
        const [mime] = file.type.split('/')

        if (mime === 'image') {
          reader.onload = () => {
            const url = reader.result
            insertImage(editor, url)
          }
          reader.readAsDataURL(file)
        }
      }
    } else {
      insertData(data)
    }
  }

  return editor
}
